import React, { Component } from "react";
import Main from './components/Main.js';
import './styles/App.css';

class App extends Component {
  render()
  {
    return (
      <Main />
    );
  }
}

export default App;
